export default function (subject) {
  if (subject) {
    return `Re: ${subject}`;
  }
  return "";
}
